import { NgModule } from '@angular/core';
import {
  ArrowKeyItemDirective,
  ArrowKeyItemHandleDirective,
} from './arrow-key-item.directive';
import { ArrowKeyNavigationDirective } from './arrow-key-navigation.directive';

@NgModule({
  declarations: [
    ArrowKeyNavigationDirective,
    ArrowKeyItemDirective,
    ArrowKeyItemHandleDirective,
  ],
  exports: [
    ArrowKeyNavigationDirective,
    ArrowKeyItemDirective,
    ArrowKeyItemHandleDirective,
  ],
})
export class ArrowKeyNavigationModule {}
